import { render, staticRenderFns } from "./LeirikoskiVihkoEdit.vue?vue&type=template&id=ba29da7c&scoped=true"
import script from "./LeirikoskiVihkoEdit.vue?vue&type=script&lang=js"
export * from "./LeirikoskiVihkoEdit.vue?vue&type=script&lang=js"
import style0 from "./LeirikoskiVihkoEdit.vue?vue&type=style&index=0&id=ba29da7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba29da7c",
  null
  
)

export default component.exports